import React from 'react';
import { useUserGuid } from '../hooks/commonHooks';

import { useIncidentRoster } from '../hooks/incidentRoster/useIncidentRoster';

const UserIncidentPositions: React.FC = () => {
  const { data: roster } = useIncidentRoster();
  const userGuid = useUserGuid();
  const userRoster = roster?.find((r) => r.userId === userGuid);

  return (
    <div>
      <h3 className="m-0 mb-3">My Positions</h3>
      <div className="d-flex flex-column gap-3">
        {userRoster &&
          userRoster.incidentPositions.map((position) => (
            <div
              key={position.positionId}
              className="incident-roster-card card"
            >
              <div className="card-body p-3">
                <strong>{position.positionName}</strong>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default UserIncidentPositions;
